module.exports = __webpack_public_path__ + "static/media/selected_icn_map_event_weather.32163a98.svg";